<template>
  <div class="messageTypeListPage">
    <XR-head titleText="消息中心" :rightShow="false" ref="headObj"></XR-head>
    <mu-list>
        <mu-list-item title="客服通知" describeText="客服在这里为您服务" to="/usercenter/messageServiceList?type=1">
          <mu-avatar src=" ../static/messageUsercenter/1.png" slot="leftAvatar"/>
          <mu-badge :content="getMsgCountById(1)" :class="getMsgClasstById(1)" circle secondary  slot="right">

          </mu-badge>
        </mu-list-item>
        <mu-list-item title="购物通知" describeText="客服在这里为您服务" to="/usercenter/messageShoppingList">
          <mu-avatar src=" ../static/messageUsercenter/2.png" slot="leftAvatar"/>
          <mu-badge :content="getMsgCountById(2)" :class="getMsgClasstById(2)" circle secondary  slot="right">

          </mu-badge>
        </mu-list-item>
        <mu-list-item title="活动通知" describeText="客服在这里为您服务" to="/usercenter/messageServiceList?type=3">
          <mu-avatar src=" ../static/messageUsercenter/3.png" slot="leftAvatar"/>
          <mu-badge :content="getMsgCountById(3)" :class="getMsgClasstById(3)" circle secondary  slot="right">

          </mu-badge>
        </mu-list-item>
        <mu-list-item title="系统公告" describeText="客服在这里为您服务" to="/usercenter/messageServiceList?type=6">
          <mu-avatar src=" ../static/messageUsercenter/4.png" slot="leftAvatar"/>
          <mu-badge :content="getMsgCountById(6)" :class="getMsgClasstById(6)" circle secondary  slot="right">

          </mu-badge>
        </mu-list-item>
    </mu-list>
  </div>
</template>

<script>

export default {
  data () {
    return {
      msgCount:{}
    }
  },
  mounted(){
    this.getMessageCount()
  },
  methods: {
    getMsgCountById(id){
      var num = 0
      for(var i = 0; i < this.msgCount.length;i++){
        if(this.msgCount[i].MessageTypeId == id){
          num = this.msgCount[i].Num
        }
      }
      if(num>99){
        num = num+'+';
      }
      return num
    },
    getMsgClasstById(id){
      var num = 0
      for(var i = 0; i < this.msgCount.length;i++){
        if(this.msgCount[i].MessageTypeId == id){
          num = this.msgCount[i].Num
        }
      }
      if(num>9){
        return 'nineplus';
      }else{
        return 'demo-icon-badge';
      }
    },
    getMessageCount(){
         
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetUserMessageTypeCount", this.searchInfo
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false          

          ths.msgCount = res.Data
        }
      });      
    }
  }
}

</script>
<style>
    .messageTypeListPage .mu-list{
      padding-bottom: 0;
      background: #fff;
    }
    .messageTypeListPage .mu-list .mu-item-title{font-weight: bold;font-size: 14px;}
    .messageTypeListPage .mu-list .mu-item-content  .mu-item-text{font-size: 12px;color: #a3a3a3;}
    .messageTypeListPage .mu-list  .mu-item-left .mu-avatar{
      width: 40px;
      height: 40px;
    }
    .messageTypeListPage .mu-list .mu-item-right .nineplus .mu-badge-circle{
      width: 30px;
      height: 16px;
      border-radius: 8px;
    }
    .messageTypeListPage .mu-list .mu-item {
      border-bottom: 1px solid #f5f5f5;
    }
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/messageTypeList.vue